import { useState, type FormEvent } from 'react';
import { signInWithPassword } from '../lib/supabase';

export function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { error: err } = await signInWithPassword(email.trim(), password);
    setBusy(false);
    if (err) setError(err.message);
    // Successful sign-in fires the auth listener in App.tsx, which
    // re-renders into the dashboard. Nothing to do here.
  }

  return (
    <div className="min-h-full flex items-center justify-center p-8">
      <form onSubmit={submit} className="w-full max-w-sm rounded-lg border border-zinc-800 bg-zinc-900/40 p-6">
        <h1 className="text-lg font-semibold text-zinc-100 mb-1 text-center">Deadunlock Bot Admin</h1>
        <p className="text-xs text-zinc-500 mb-6 text-center">Sign in with your admin account.</p>

        {error && (
          <div className="rounded border border-rose-800/50 bg-rose-950/30 px-3 py-2 text-xs text-rose-300 mb-4">
            {error}
          </div>
        )}

        <label className="block text-xs text-zinc-400 mb-1">Email</label>
        <input
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={busy}
          className="w-full px-3 py-2 rounded-lg bg-zinc-950 border border-zinc-700 text-sm text-zinc-100 mb-3 focus:outline-none focus:border-amber-500 disabled:opacity-50"
        />

        <label className="block text-xs text-zinc-400 mb-1">Password</label>
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={busy}
          className="w-full px-3 py-2 rounded-lg bg-zinc-950 border border-zinc-700 text-sm text-zinc-100 mb-5 focus:outline-none focus:border-amber-500 disabled:opacity-50"
        />

        <button
          type="submit"
          disabled={busy}
          className="w-full px-4 py-2 rounded-lg bg-amber-400 hover:bg-amber-300 text-zinc-950 text-sm font-semibold disabled:opacity-50 cursor-pointer"
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="text-[11px] text-zinc-500 mt-4 text-center">
          Accounts are created in the Supabase dashboard, not here.
        </p>
      </form>
    </div>
  );
}
